import React from 'react'
import { CopyrightOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import { useNavigate } from 'react-router-dom';
function Foot() {
    const navi = useNavigate()
    return (
        <div style={{textAlign:'center',background:"#eee",padding:"30px 0"}}>
            <Space 
                direction='vertical'
                size={30}
            >
                <Space size={20}>
                    <a onClick={() => {navi('/')}}>软件教程</a>
                    <a 
                        onClick={() => {
                            window.open('https://work.weixin.qq.com/kfid/kfcc1a9500fb365f216')
                        }}
                    
                    >在线客服</a>
                </Space>
                <Space size={20}>
                    <div>
                        <CopyrightOutlined /> 2002 - 现在 bnsrj.com copyRight
                    </div>
                    <a                    
                        onClick={() => {window.open('https://www.bnsrj.com')}} 
                    >湖北伯纳思网络科技有限公司</a>
                    <a target="_blank" onClick={() => {window.open('https://beian.miit.gov.cn/')}} style={{cursor:'pointer'}}>鄂ICP备18025660号-6</a>
                </Space>                       
            </Space>
        </div>
        
    )
}

export default Foot